export const SCREEN_RESIZE = '@app/SCREEN_RESIZE';
export const URL_STATE = 'keen_explorer_state';
export const QUERY_AUTORUN_KEY = '@keen-explorer/query-autorun';
export const DEFAULT_PROPERTY = 'displayName';
export const DEFAULT_DIRECTION = 'ascending';
